import { createLazyComponent, LazyAction, LazyImport, LazyModule, type LazyComponent, } from "owa-bundling";
import { isCalendarSchedulingDialogOpen } from "owa-calendar-scheduling-dialog-store";
import { GovernPriority } from "owa-client-types/lib/GovernPriority";
import type * as lazyIndex from "./lazyIndex";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "CalendarSchedulingDialog" */ "./lazyIndex"), { name: "CalendarSchedulingDialog", govern: GovernPriority.Calendar });

export type { GetSchedulingDraftProps, SchedulingDraft } from "./types/SchedulingDraft";
export const lazyGetSchedulingDraft: LazyAction<typeof lazyIndex.getSchedulingDraft, typeof lazyModule> = new LazyAction(lazyModule, m => m.getSchedulingDraft);
export const lazyLaunchSchedulingDraftForReview: LazyImport<typeof lazyIndex.launchSchedulingDraftForReview, typeof lazyModule> = new LazyImport(lazyModule, m => m.launchSchedulingDraftForReview);

export const CalendarSchedulingDialog: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.CalendarSchedulingDialog, undefined, undefined, {
    onlyImportIf: isCalendarSchedulingDialogOpen,
});
